module.exports = __webpack_public_path__ + "img/xy3@2x.94155839.png";